/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import i18n functions */
import { useI18n } from '@/context/I18nContext';

/* Import components */
import OverviewAggregatedCard from '@/components/tabs/overview/metrics/cards/OverviewAggregatedCard';

/* Import types */
import type { OverviewAnomalyCardData } from '@/lib/overview/overviewSystemAggregation';

interface OverviewAnomalyCardProps {
    card: OverviewAnomalyCardData;
    showKpis: boolean;
}

function OverviewAnomalyCard({ card, showKpis }: OverviewAnomalyCardProps) {
    const { t } = useI18n();

    return (
        <OverviewAggregatedCard
            ariaLabel={t(card.anomalyConfig.label)}
            card={card}
            description={t(card.anomalyConfig.description)}
            icon={card.anomalyConfig.icon}
            kpiGridClassName={card.anomalyConfig.kpiGridClassName}
            showKpis={showKpis}
            title={t(card.anomalyConfig.label)}
            to={card.anomalyConfig.route}
        />
    );
}

export default OverviewAnomalyCard;
